import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

export type NavItem = { key: string; label: string; group: string; status?: 'live' | 'coming-soon' };

export function NavMenu({ items, active, onSelect }: { items: NavItem[]; active: string; onSelect: (k:string)=>void }) {
  const { t, i18n } = useTranslation();
  const liveItems = items.filter((i) => i.status === 'live');
  const regularItems = items.filter((i) => i.status !== 'live');
  const groups = Array.from(new Set(regularItems.map(i=>i.group)));
  const trNav = (label: string) => {
    const key = `navigation.${label}`;
    const translated = t(key);
    return translated === key ? label : translated;
  };
  const liveHeader = `🟢 ${t('nav.liveModules') || (i18n.language?.startsWith('hu') ? 'Aktív modulok' : 'Live modules')}`;

  return (
    <aside className="w-full md:w-64 shrink-0 border-r border-evat-gold/30 pr-4 overflow-y-auto">
      <div className="mb-4">
        <div className="text-xs uppercase tracking-wide text-emerald-400 mb-2">{liveHeader}</div>
        <div className="flex flex-col gap-1">
          {liveItems.map((i) => (
            <motion.button
              key={i.key}
              whileTap={{ scale: 0.98 }}
              onClick={() => onSelect(i.key)}
              aria-label={`Navigate to ${trNav(i.label)}`}
              className={`text-left px-3 py-1 rounded border focus:outline-none focus:ring-2 focus:ring-evat-neon/50 ${
                active===i.key
                  ? 'border-evat-neon text-evat-neon'
                  : 'border-transparent text-neutral-100 hover:border-evat-gold/40'
              }`}
            >
              {trNav(i.label)}
            </motion.button>
          ))}
        </div>
      </div>

      <div className="border-t border-evat-gold/20 my-3" />

      {groups.map((g)=> (
        <div key={g} className="mb-3">
          <div className="text-xs uppercase tracking-wide text-evat-gold/80 mb-1">{trNav(g)}</div>
          <div className="flex flex-col gap-1">
            {regularItems.filter(i=>i.group===g).map((i)=> (
              <motion.button key={i.key} whileTap={{ scale: 0.98 }} onClick={()=>onSelect(i.key)} aria-label={`Navigate to ${trNav(i.label)}`}
                className={`text-left px-3 py-1 rounded border focus:outline-none focus:ring-2 focus:ring-evat-neon/50 ${active===i.key? 'border-evat-neon text-evat-neon' : 'border-transparent text-neutral-300 hover:border-evat-gold/40 opacity-60'} `}>
                <span>{trNav(i.label)}</span>
                <span className="ml-2 text-[10px] px-1.5 py-0.5 rounded bg-neutral-700/60 text-neutral-300 align-middle">
                  {t('nav.comingSoon') || 'Coming soon'}
                </span>
              </motion.button>
            ))}
          </div>
        </div>
      ))}
    </aside>
  );
}

export default NavMenu;


